import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress XMLHttpRequest.responseText warnings from blob downloads
// This happens when Emergent monitoring tries to access responseText on blob responses
if (typeof window !== 'undefined') {
  const originalError = console.error;
  console.error = function(...args) {
    // Filter out XMLHttpRequest.responseText errors
    const firstArg = args[0];
    if (
      typeof firstArg === 'string' &&
      (firstArg.includes('XMLHttpRequest.responseText') ||
       firstArg.includes('responseText is only available'))
    ) {
      return; // Suppress this specific error
    }
    originalError.apply(console, args);
  };

  // Also suppress runtime errors from Emergent monitoring
  window.addEventListener('error', function(event) {
    if (
      event.message &&
      (event.message.includes('XMLHttpRequest.responseText') ||
       event.message.includes('responseText is only available'))
    ) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  }, true);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
